import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import { CLASSNAME } from '../../components/blocks/LinkPreview';
import type { LinkPreviewElement } from '../../types';

export const LINK_PREVIEW_ELEMENTS: HTMLSerializeOptions['elements'] = {
    'link-preview': (node: LinkPreviewElement) => {
        const linkPreviewInfo = {
            url: node.url,
            thumbnailUrl: node.thumbnailUrl,
            resource: node.resource,
        };
        const title = node.title ? `<h4>${escapeHTML(node.title)}</h4>` : '';
        const description = node.description ? `<p>${escapeHTML(node.description)}</p>` : '';
        return `<article class="${CLASSNAME}" data-link-preview-info="${escapeHTML(
            JSON.stringify(linkPreviewInfo),
        )}">${title}${description}</article>`;
    },
};
